import React from 'react'

/**
 * Gets the empty div to style if an icon is suspended
 * @param size string representing size including px or %
 * @returns A div to with the style applied to heigh and width that is passed in
 */
export const getLazyFallbackIconForSize = (size: string) => {
  return (
    <div
      data-testid="lazy-icon"
      style={{
        height: size,
        width: size,
      }}
    />
  )
}
